export default (index: number): string => {
  switch (index) {
    case 0:
      return '#3E82FC';
    case 1:
      return '#32BF84';
    case 2:
      return '#FF6163';
    case 3:
      return '#f39c12';
    default:
      return '#8F8CE7';
  }
};
